@media all and (-ms-high-contrast:none) {
	.cb-panels {
		.cb-panels_panel {
			flex-basis: auto;
			width: 100%;


			@include min(768px) {
				width: 33.33%;
			}
        }

        &.cols-four {
            .cb-panels_panel {
                @include min(768px) {
                    width: 25%;
                }
            }
        }

        &.cols-five {
            .cb-panels_panel {
                @include min(768px) {
                    width: 20%;
                }
            }
        }
	}

	.cb-team {
		.team_member {
			flex-basis: auto;
			width: 100%;

			@include min(500px) {
				width: 50%;
			}

			@include min(768px) {
				width: 33.3333%;
			}

			@include min(1024px) {
				width: 25%;
			}

			@include min(1200px) {
				width: 20%;
			}
		}
	}

	.layout-footer {
		.content-layout_column {
			flex-basis: auto;
			width: 25%;
		}
	}

	.layout-3 {
		.col {
			flex-basis: auto;
			width: 33.33%;
		}
	}

	.layout-2 {
		.col {
			flex-basis: auto;
			width: 50%;
		}
	}

	.content-layout_1-1-1 {
		.content-layout_column {
			flex-basis: auto;
			width: 100%;

			@include min(768px) {
				width: 33.33%;
			}
		}
	}

	.cb-discounts {
		.wrap {
			margin-left: 0;
			margin-right: 0;
		}
	}

	.cb-hero:before,
	.cb-banner:before,
	.cb-quote:before,
	.cb-big-video {
		background-image: url(/site/images/flower.png);
	}
}



@supports (-ms-ime-align: auto) {
	.cb-hero:before,
	.cb-banner:before,
	.cb-quote:before,
	.cb-big-video {
		background-image: url(/site/images/flower.png);
	}
}